import { fetchManpowerSummaryReports } from "@api/manpowerSummaryReports";
import { useEffect, useState } from "react";

export const useManpowerSummaryReports = () => {
  const [getManpowerSummaryData, setGetManpowerSummaryData] = useState<any>({});
  const [getManpowerSummaryDataError, setGetManpowerSummaryDataError] =
    useState(false);
  const [query, setQuery] = useState<any>(null);

  const [unitId, setUnitId] = useState<number | null>(null);

  const handleParams = (id: number) => setUnitId(id);

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev: any) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    if (unitId) {
      fetchManpowerSummaryReports(unitId)
        .then((data: any) => {
          if (data?.resData?.data?.length) {
            data?.resData?.data?.push({
              id: data?.resData?.data?.length + 1,
              positionNameBn: "মোট",
              totalPost: data?.resData?.totalPost,
              totalEmployee: data?.resData?.totalEmployee,
              vacancy: data?.resData?.vacancy,
            });
          }
          setGetManpowerSummaryData(data?.resData);
        })
        .catch((err: any) => {
          setGetManpowerSummaryDataError(true);
        });
    }
  }, [unitId]);

  return {
    handleQuery,
    getManpowerSummaryData,
    getManpowerSummaryDataError,
    handleParams,
  };
};
